import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../logo.webp";
import "./Navbar.css";

const Navbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 900) {
        setMenuOpen(false);
        setDropdownOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          <img src={logo} alt="Qeeper Logo" />
        </Link>
      </div>

      <button
        className={`navbar-burger ${menuOpen ? "open" : ""}`}
        onClick={() => {
          setMenuOpen(!menuOpen);
          setDropdownOpen(false);
        }}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul className={`navbar-links ${menuOpen ? "navbar-links--open" : ""}`}>
        <li>
          <Link to="/" onClick={() => setMenuOpen(false)}>
            Home
          </Link>
        </li>
        <li
          className="navbar-dropdown"
          onMouseEnter={() => setDropdownOpen(true)}
          onMouseLeave={() => setDropdownOpen(false)}
        >
          <button
            className="navbar-dropdown-toggle"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            Services <span className="dropdown-arrow">&#9662;</span>
          </button>
          {dropdownOpen && (
            <ul className="navbar-dropdown-menu">
              <li>
                <Link
                  to="/about/features"
                  onClick={() => {
                    setMenuOpen(false);
                    setDropdownOpen(false);
                  }}
                >
                  Features
                </Link>
              </li>
              <li>
                <Link
                  to="/about/services"
                  onClick={() => {
                    setMenuOpen(false);
                    setDropdownOpen(false);
                  }}
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/about/projects"
                  onClick={() => {
                    setMenuOpen(false);
                    setDropdownOpen(false);
                  }}
                >
                  Projects
                </Link>
              </li>
            </ul>
          )}
        </li>
        <li>
          <Link to="/components" onClick={() => setMenuOpen(false)}>
            Components
          </Link>
        </li>
        <li>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>
            Contact
          </Link>
        </li>
      </ul>

      <Link
        to="/contact"
        className="navbar-cta"
        onClick={() => setMenuOpen(false)}
      >
        Get in touch
      </Link>

      {menuOpen && (
        <div
          className="navbar-overlay"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
    </nav>
  );
};

export default Navbar;
